// @ts-ignore
import useEffectDataLayerGA4ViewItem from '@sprinx/cvo-eshop-ui-common/hooks/useEffectDataLayerGA4ViewItem';
// @ts-ignore
import ProductDetailPageLayout from '@sprinx/cvo-eshop-ui-common/pages/ProductDetailPage/ProductDetailPageLayout';
import React from 'react';
import { AfterPage, AfterPageProps } from '../../@sprinx/after-razzle';
import commonData from '../../api/commonData';
import productData from '../../api/productData';
import AppLayout from '../../layouts/AppLayout';
import { ProductDetailPageData } from '../../types/ProductDetailPageData';
import ErrorPage from '../ErrorPage';
import NotFoundPage from '../NotFoundPage';
// @ts-ignore
// import ProductDetailPageLayout from './ProductDetailPageLayout';

export interface ProductDetailPageProps extends AfterPageProps<ProductDetailPageRouteParams> {
  data?: ProductDetailPageData;
}

interface ProductDetailPageRouteParams {
  kod?: string;
}

const ProductDetailPage: AfterPage<ProductDetailPageRouteParams, ProductDetailPageProps> = ({ data, error }) => {
  if (error) return <ErrorPage error={error} />;
  if (!data) return <NotFoundPage />;

  const { product, layout } = data;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffectDataLayerGA4ViewItem(product);

  return (
    <AppLayout headerProps={layout.header} footerProps={layout.footer}>
      {/* @ts-ignore */}
      <ProductDetailPageLayout product={product} />
    </AppLayout>
  );
};

ProductDetailPage.getInitialProps = async ({ match }) =>
  /* {
    match, initialAppProps
  },*/
  {
    const layout = await commonData.get();
    const kod = match.params?.kod;
    if (kod) {
      const product = await productData.get({ kod });
      const data: ProductDetailPageData = {
        product,
        title: 'aa',
        layout,
      };

      return {
        data,
      };
    }
    return {};
  };

export default ProductDetailPage;
